import { makeStyles } from '@material-ui/core/styles'
import { COLORS, WIDTH_DIMENSIONS, BREAKPOINTS, FONTS } from '../constants'

export const styles = makeStyles(theme => ({
  headingWrapper: {
    width: '100%',
    background: COLORS.whiteStain,
    padding: '32px 0', // no horizontal padding above md — inner container is 90% wide, like productsContainer
    marginBottom: 32,
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      padding: '20px 16px',
      marginBottom: 24,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      padding: '16px 12px',
      marginBottom: 16,
    },
  },
  headingContainer: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
    maxWidth: WIDTH_DIMENSIONS.max,
    margin: 'auto',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: 16,
    },
  },
  headingTextContainer: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    minWidth: 0, // lets long titles wrap instead of overflowing the row
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      alignItems: 'flex-start', // keep logo aligned to the title's first line once it wraps
    },
  },
  headingLogoImage: {
    width: 100,
    height: 100,
    flexShrink: 0,
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      width: 80,
      height: 80,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      width: 56,
      height: 56,
    },
  },
  headingLogoText: {
    minWidth: 0,
    paddingLeft: 21,
    overflowWrap: 'anywhere',
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      paddingLeft: 12,
    },
  },
  chirpyestPageTitle: {
    lineHeight: '34px',
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      fontSize: '20px !important',
      lineHeight: '23px !important',
    },
  },
  chirpyestPageHeader: {
    lineHeight: '80px !important',
    fontSize: '80px !important',
    marginBottom: '16px !important',
    maxWidth: '100%',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      lineHeight: '70px !important',
      fontSize: '64px !important',
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      lineHeight: '62px !important',
      fontSize: '56px !important',
      marginBottom: '8px !important',
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      lineHeight: '50px !important',
      marginBottom: '4px !important',
      fontSize: '45px !important',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      lineHeight: '36px !important',
      fontSize: '32px !important',
    },
  },
  description: {
    fontSize: '16px !important',
    lineHeight: '23px !important',
    fontFamily: FONTS.Graphik.GraphikLight + ' !important',
    marginBottom: 0,
    marginLeft: 0,
  },
  actionButtonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto', // sizes to content on desktop, stretches full width once the header stacks
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '100%',
    },
  },
  productsContainer: {
    fontFamily: FONTS.Graphik.GraphikLight,
    width: '100%',
    margin: '0 auto',
    overflow: 'hidden',
    maxWidth: WIDTH_DIMENSIONS.max,
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      width: '90%',
    },
  },
  // Same horizontal padding as headingWrapper below lg, so both rows stay aligned.
  countingFilterContainer: {
    display: 'flex',
    marginBottom: 20,
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      paddingLeft: 16,
      paddingRight: 16,
      marginBottom: 16,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      paddingLeft: 12,
      paddingRight: 12,
      marginBottom: 12,
    },
  },
  // `& > div` targets ItemsPerPageFilter's root: caps its width so the tint
  // hugs the control (not the wider Grid cell) and right-aligns it here.
  itemsPerPageCell: {
    display: 'flex',
    justifyContent: 'flex-end',
    ['& > div']: {
      width: '100%',
      maxWidth: 220,
      backgroundColor: COLORS.whiteStain,
    },
  },
  itemsCount: {
    color: COLORS.ashGrey,
    fontFamily: FONTS.Graphik.GraphikRegular,
    fontSize: '1rem',
    letterSpacing: '1px',
    lineHeight: '18p',
    textTransform: 'uppercase',
  },
  joinCard: {
    backgroundColor: COLORS.whiteStain,
    height: 454,
    paddingTop: 50,
    paddingLeft: 50,
    paddingRight: 50,
    display: 'flex',
    alignItems: 'center',
  },
  joinCardText: {
    fontSize: '3.22rem',
    textAlign: 'center',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  btn: {
    background: 'white',
    color: theme.palette.common.black,
    transition: '0.5s',
    maxWidth: 300,
    margin: '0 0 0 auto',
    ['&:focus']: {
      outline: 'none',
    },
    ['& > p']: {
      color: theme.palette.common.black,
    },
    ['&:hover']: {
      color: theme.palette.common.white,
      background: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      ['& > p']: {
        color: theme.palette.common.white,
      },
    },
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      maxWidth: '100%',
      margin: 0,
    },
  },
  btnOther: {
    ['& > p']: {
      padding: '0 20px',
      width: '100%',
      justifyContent: 'center',
    },
    ['&:hover']: {
      ['& > img']: {
        filter: 'invert(100%)',
      },
    },
  },
  forwardedFolderLink: {
    position: 'relative',
    width: '100%',
    maxWidth: 400,
    marginLeft: 'auto',
    ['& > input']: {
      color: theme.palette.common.black,
      letterSpacing: 1.2,
      textAlign: 'center',
      background: 'white',
      border: `1px solid ${COLORS.lightGrey}`,
    },
    ['& > button']: {
      position: 'absolute',
      right: 0,
      top: 0,
      width: '100px',
      margin: 0,
    },
  },
}))
